angular.module('impactx.numberingscheme').controller("NumberingSchemeCtrl", NumberingSchemeCtrl);
NumberingSchemeCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    '$redirect',
    'ToolbarService'
];

function NumberingSchemeCtrl($scope, dataGen, $routeParams, BackService, $mdToast, $redirect, ToolbarService) {
    var id = 0;
    if ($routeParams.id) {
        id = $routeParams.id;
    }

    var ctrl = this;

    var alwaysSetCurrentToStart = false;
    ctrl.maxLengthValue = 9;

    var initWatchers = function () {
        // pattern watcher
        $scope.$watch(function () {
            return $scope.data.pattern.value;
        }, function (newVal, oldVal) {
            if (newVal === "" || (newVal && newVal !== oldVal)) // pattern may be empty string but
            {
                ctrl.refreshValues();
            }
        });
        // startDate watcher
        $scope.$watch(function () {
            return $scope.data.startDate.dateValue;
        }, function (newVal, oldVal) {
            if (newVal === null || newVal && newVal !== oldVal) // date may be null but not undefined
            {
                ctrl.refreshValues();
            }
        });
        // endDate watcher
        $scope.$watch(function () {
            return $scope.data.endDate.dateValue;
        }, function (newVal, oldVal) {
            if (newVal === null || newVal && newVal !== oldVal) // date may be null but not undefined
            {
                ctrl.refreshValues();
            }
        });
        // company watcher — clears selectedComOnly when company selection is removed
        $scope.$watch(function () {
            return $scope.data.company.selected;
        }, function (newVal) {
            if (!newVal || !newVal.value) {
                $scope.data.selectedComOnly.value = false;
            }
        });
    };

    ctrl.getData = function () {
        var param = {
            id: id
        };
        var tmp = {};
        dataGen.getData(tmp, param, "/numberingscheme/view").then(function () {
            $scope.data = tmp.data;
            $scope.trns = tmp.trns;
            // always change current value to start value if the schema is new -> id == 0
            // or was not used yet -> current value is (still) equal to start value
            // do not check this if data was changed
            alwaysSetCurrentToStart = $scope.data.id === 0 || $scope.data.currentValue === $scope.data.startValue.value;
            initWatchers();
            defineButtons();
        });
    };

    ctrl.varSelectionChanged = function (variable, selectedItem) {
        if (selectedItem) {
            variable.selected = selectedItem;
            ctrl.refreshValues();
        }
    };

    ctrl.refreshValues = function () {
        if (alwaysSetCurrentToStart ||
            ($scope.data.startValue.value && $scope.data.startValue.value > $scope.data.currentValue)) {
            $scope.data.currentValue = $scope.data.startValue.value;
        }
        var dataObj = {
            data: $scope.data
        };
        var response = {};
        dataGen.postAsForm(response, dataObj, "/numberingscheme/format").then(function () {
            if (response.data) {
                $scope.data.currentValueFormatted.value = response.data.current;
                $scope.data.startValueFormatted = response.data.start;
                $scope.data.endValueFormatted = response.data.end;
            }
        });
    };

    ctrl.addVariable = function () {
        if ($scope.data.variables.length < 11) {
            var response = {};
            dataGen.getData(response, {pos: $scope.data.variables.length, usageType: $scope.data.usageType.selected.id }, "/numberingscheme/addvariable").then(function () {
                if (response.data) {
                    $scope.data.variables.push(response.data);
                    var pattern = $scope.data.pattern.value || "";
                    $scope.data.pattern.value = pattern + response.data.variableIndex;
                    ctrl.refreshValues();
                }
            });
        }
    };

    // toDelete is a NUSVarPopupProperty
    ctrl.deleteVariable = function (toDelete) {
        var dataObj = {
            variables: $scope.data.variables,
            pattern: $scope.data.pattern.value,
            toDelete: toDelete.variableIndex
        };
        var response = {};
        dataGen.postAsForm(response, dataObj, "/numberingscheme/delvariable").then(function () {
            $scope.data.variables = response.data.variables;
            $scope.data.pattern.value = response.data.pattern;

            ctrl.refreshValues();
        });
    };

    ctrl.save = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm({}, dataObj, "/numberingscheme/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    ctrl.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        return dataGen.postAsForm({}, dataObj, "/numberingscheme/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    ctrl.createSuccessor = function () {
        var dataObj = {
            data: $scope.data
        };
        var response = {};
        return dataGen.postAsForm(response, dataObj, "/numberingscheme/save").then(function () { // first save the current one to be sure to get an id
            if (response.data && response.data.id > 0) {
                var param = {
                    id: response.data.id
                };
                var successor = {};
                dataGen.postAsForm(successor, param, "/numberingscheme/successor").then(function () { // now get data from the successor
                    if (successor.data) {
                        $scope.data = successor.data;

                        // reset any data that should not be set at this point
                        var data = $scope.data;
                        data.endValue.value = null;
                        data.currentValue = data.startValue.value;
                        data.endDate.value = "";
                        data.endDate.dateValue = null;
                        data.warningValue.value = null;
                        data.warningDate.value = "";
                        data.warningDate.dateValue = null;
                        // since we have a new schema...
                        alwaysSetCurrentToStart = true;

                        ctrl.refreshValues();
                    }
                });
            }
        });
    };

    ctrl.changeMinMaxDigits = function () {
        if ($scope.data.useMinDigits || $scope.data.useMaxDigits) {
            $scope.data.useFixDigits = false;
        }
        ctrl.refreshValues();
    };

    ctrl.changeFixDigits = function () {
        if ($scope.data.useFixDigits) {
            $scope.data.useMinDigits = false;
            $scope.data.useMaxDigits = false;
        }
        ctrl.refreshValues();
    };

    ctrl.select = function (id) {
        if ($scope.selected === id) {
            $scope.selected = 0;
        }
        else {
            $scope.selected = id;
        }
    };

    ctrl.goToSelected = function () {
        $redirect.redirectTo(null, "/numberingscheme/" + $scope.selected)
    };

    ctrl.getData();

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                labelFunction: createSuccessorLabel,
                action: ctrl.createSuccessor,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                labelFunction: getGoToSelectedLabel,
                action: ctrl.goToSelected,
                type: 'dialogaction',
                condition: canGoToSelected
            },
            {
                label: $scope.trns.delete,
                action: ctrl.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDelete() {
        return $scope.data.id > 0;
    }

    function getGoToSelectedLabel() {
        return $scope.trns.numberingScheme + " " + $scope.trns.edit;
    }

    function createSuccessorLabel() {
        return $scope.trns.successor + " " + $scope.trns.add;
    }

    function canGoToSelected() {
        return $scope.selected > 0;
    }
}